import { render, staticRenderFns } from "./cust-layout.vue?vue&type=template&id=fffde000&scoped=true"
import script from "./cust-layout.vue?vue&type=script&lang=js"
export * from "./cust-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffde000",
  null
  
)

export default component.exports